<template>
  <div class="detail-container">
    <!-- 加载中 -->
    <el-card v-loading="loading" class="main-card" v-if="!loading">
      <div v-if="order" class="content-wrap">
        <!-- 酒店信息 + 房型信息 并列 -->
        <el-row :gutter="20">
          <el-col :span="12">
            <div class="info-card first-info-card">
              <div class="card-title hotel_title">
                酒店信息（{{ supplierTypeText }}）
              </div>
              <div class="field-row">
                <span class="field-label">Inned_ID：</span>
                <span class="field-value">{{
                  order.hotel?.inn_id || '-'
                }}</span>
              </div>
              <div class="field-row">
                <span class="field-label">酒店名称：</span>
                <span class="field-value">{{
                  order.hotel?.inn_name || '-'
                }}</span>
              </div>
              <div class="field-row">
                <span class="field-label">酒店电话：</span>
                <span class="field-value">{{
                  order.hotel?.inn_phone || '-'
                }}</span>
              </div>
              <div class="field-row">
                <span class="field-label">酒店地址：</span>
                <span class="field-value">{{
                  order.hotel?.address || '-'
                }}</span>
              </div>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="info-card">
              <div class="card-title">房型信息</div>
              <el-row :gutter="16">
                <el-col :span="12">
                  <div class="field-row">
                    <span class="field-label">房型ID</span>
                    <span class="field-value">{{
                      order.room_type?.id || '-'
                    }}</span>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="field-row">
                    <span class="field-label">早餐</span>
                    <span class="field-value">{{ breakfastText || '-' }}</span>
                  </div>
                </el-col>
              </el-row>
              <el-row :gutter="16">
                <el-col :span="12">
                  <div class="field-row">
                    <span class="field-label">房型名称</span>
                    <span class="field-value">{{
                      order.room_type?.room_type_name || '-'
                    }}</span>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="field-row">
                    <span class="field-label">取消规则</span>
                    <span class="field-value">{{ cancelRuleText || '-' }}</span>
                  </div>
                </el-col>
              </el-row>
              <el-row :gutter="16">
                <el-col :span="12">
                  <div class="field-row">
                    <span class="field-label">售卖间数</span>
                    <span class="field-value">{{ order.room_num || '-' }}</span>
                  </div>
                </el-col>
              </el-row>
            </div>
          </el-col>
        </el-row>

        <!-- 下单信息 -->
        <div class="info-card" style="margin-top: 16px">
          <div class="card-title">下单信息</div>
          <el-row :gutter="16" class="order-row">
            <el-col :span="7">
              <div class="field-row">
                <span class="field-label">订单号</span>
                <span class="field-value">{{ order.order_id || '-' }}</span>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="field-row">
                <span class="field-label">系统订单状态</span>
                <span class="field-value">
                  <el-tag
                    :type="systemOrderStatusTag(order.system_order_status)"
                    size="mini"
                    >{{
                      systemOrderStatusText(order.system_order_status)
                    }}</el-tag
                  >
                </span>
              </div>
            </el-col>
            <el-col :span="5">
              <div class="field-row">
                <span class="field-label">用户下单金额</span>
                <span class="field-value">{{
                  order.channel_money ?? '-'
                }}</span>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="field-row">
                <span class="field-label">下单到店时间</span>
                <span class="field-value">{{
                  order.last_arr_time || '-'
                }}</span>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="16" class="order-row">
            <el-col :span="7">
              <div class="field-row">
                <span class="field-label">供应商订单号</span>
                <span class="field-value">{{ order.order_code || '-' }}</span>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="field-row">
                <span class="field-label">供应商订单状态</span>
                <span class="field-value">
                  <el-tag
                    :type="orderStateTag(order.order_state)"
                    size="mini"
                    >{{ orderStateText(order.order_state) }}</el-tag
                  >
                </span>
              </div>
            </el-col>
            <el-col :span="5">
              <div class="field-row">
                <span class="field-label">供应商成本价</span>
                <span class="field-value">{{
                  order.actual_total_rate ?? '-'
                }}</span>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="field-row">
                <span class="field-label">入住时间</span>
                <span class="field-value">{{ order.travel_date || '-' }}</span>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="16" class="order-row">
            <el-col :span="7">
              <div class="field-row">
                <span class="field-label">系统订单号</span>
                <span class="field-value">{{
                  order.system_order_no || '-'
                }}</span>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="field-row">
                <span class="field-label">下单时间</span>
                <span class="field-value">{{ order.order_date || '-' }}</span>
              </div>
            </el-col>
            <el-col :span="5">
              <div class="field-row">
                <span class="field-label">合作商渠道价</span>
                <span class="field-value">{{
                  order.actual_channel_money ?? '-'
                }}</span>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="field-row">
                <span class="field-label">离店时间</span>
                <span class="field-value">{{
                  order.end_travel_date || '-'
                }}</span>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="16" class="order-row">
            <el-col :span="7">
              <div class="field-row">
                <span class="field-label">确认号</span>
                <span class="field-value">{{
                  order.order_confirm_no || '-'
                }}</span>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="field-row">
                <!-- <span class="field-label"></span>
                <span class="field-value"></span> -->
              </div>
            </el-col>
            <el-col :span="5">
              <div class="field-row">
                <span class="field-label">已扣额度</span>
                <span class="field-value">{{ order.quota_value ?? '-' }}</span>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="field-row">
                <span class="field-label">实际离店时间</span>
                <span class="field-value">{{
                  order.actual_end_travel_date || '-'
                }}</span>
              </div>
            </el-col>
          </el-row>
        </div>

        <!-- 入住信息 -->
        <div class="info-card" style="margin-top: 16px">
          <div class="card-title">入住信息</div>

          <div
            v-for="(passenger, pIndex) in passengerList"
            :key="pIndex"
            class="guest-section"
            :style="{ marginTop: pIndex > 0 ? '20px' : '0' }"
          >
            <div class="guest-title">入住人 {{ pIndex + 1 }}</div>
            <div class="field-row">
              <span class="field-label">入住人姓名</span>
              <span class="field-value">{{ passenger.guest_name || '-' }}</span>
              <span class="field-label" style="margin-left: 40px">手机号</span>
              <span class="field-value">{{
                passenger.guest_mobile || '-'
              }}</span>
            </div>
            <div class="field-row" v-if="passenger.guest_id_card">
              <span class="field-label">身份证号</span>
              <span class="field-value">{{ passenger.guest_id_card }}</span>
            </div>
            <el-table
              :data="passenger.night_prices"
              border
              fit
              size="small"
              class="guest-table"
              max-height="200"
            >
              <el-table-column label="入住日期" align="center" min-width="200">
                <template slot-scope="scope">{{
                  scope.row.night_date || '-'
                }}</template>
              </el-table-column>
              <el-table-column
                label="合作商渠道价"
                align="center"
                min-width="180"
              >
                <template slot-scope="scope">{{
                  scope.row.sell_price ?? '-'
                }}</template>
              </el-table-column>
              <el-table-column
                label="供应商成本价"
                align="center"
                min-width="180"
              >
                <template slot-scope="scope">{{
                  scope.row.cost_price ?? '-'
                }}</template>
              </el-table-column>
            </el-table>
          </div>

          <div
            v-if="passengerList.length === 0"
            style="color: #999; text-align: center; padding: 20px"
          >
            暂无入住人信息
          </div>
        </div>

        <!-- 返回按钮 -->
        <div class="footer-btn" v-if="!dialogMode">
          <el-button type="primary" @click="$router.back()" icon="el-icon-back"
            >返回</el-button
          >
        </div>
      </div>

      <!-- 无数据 -->
      <el-empty v-else description="未找到订单信息"></el-empty>
    </el-card>
  </div>
</template>

<script>
import request from '@/utils/request'

export default {
  props: {
    orderId: {
      type: [String, Number],
      default: '',
    },
    dialogMode: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      order: null,
      loading: true,
      currentStep: 1,
      breakfastText: '',
      cancelRuleText: '',
      passengerList: [],
    }
  },
  computed: {
    supplierTypeText() {
      if (!this.order?.target_type) return '未知'
      return this.order.target_type === 'jin_jiang' ? '锦江' : '龙腾'
    },
  },
  created() {
    const orderId = this.orderId || this.$route.query.order_id
    if (orderId) {
      this.fetchOrderDetail(orderId)
    } else {
      this.loading = false
    }
  },
  methods: {
    fetchOrderDetail(orderId) {
      this.loading = true
      request({
        url: '/api/backend/order/orderDetail',
        method: 'get',
        params: {
          order_id: orderId,
        },
      })
        .then((response) => {
          const data = response.data
          if (data) {
            this.order = data.order || data
            this.passengerList = data.passenger_list || []
            this.processOrderData()
          }
        })
        .catch(() => {
          this.$message.error('获取订单详情失败')
        })
        .finally(() => {
          this.loading = false
        })
    },
    processOrderData() {
      const order = this.order

      // 早餐信息 - 从每晚价格中取第一条
      if (order.night_prices && order.night_prices.length > 0) {
        this.breakfastText = order.night_prices[0].breakfast_text || '-'
      }

      // 取消规则（如果没有对应字段则显示占位）
      this.cancelRuleText = order.cancel_text || '-'
    },
    // 供应商订单状态
    orderStateText(state) {
      const map = {
        1: '预订成功',
        2: '已取消',
        3: '预订未到',
        4: '已入住',
        5: '已完成',
      }
      return map[state] || '-'
    },
    orderStateTag(state) {
      const map = {
        1: 'primary',
        2: 'danger',
        3: 'warning',
        4: 'warning',
        5: 'success',
      }
      return map[state] || 'info'
    },
    // 系统订单状态
    systemOrderStatusText(status) {
      const map = {
        100: '下单待处理',
        101: '下单成功',
        102: '下单失败',
        201: '取消订单成功',
        202: '取消订单失败',
      }
      return map[status] || '-'
    },
    systemOrderStatusTag(status) {
      const map = {
        100: 'info',
        101: 'success',
        102: 'danger',
        201: 'success',
        202: 'danger',
      }
      return map[status] || 'info'
    },
  },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.detail-container {
  max-width: 2000px;
  width: 100%;
  padding: 20px;
  overflow-x: auto;
}

/* 顶部状态标识 */
.status-bar {
  display: flex;
  align-items: center;
  gap: 30px;
  margin-bottom: 20px;
  padding: 16px 20px;
  background: #fff;
  border-radius: 6px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.step-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.step-num {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: #e9ecef;
  color: #999;
  font-size: 14px;
  font-weight: 600;
}

.step-item.active .step-num {
  background: #f5a623;
  color: #fff;
}

.step-label {
  font-size: 14px;
  color: #666;
}

.step-item.active .step-label {
  color: #303133;
  font-weight: 600;
}

/* 主卡片 */
.main-card {
  min-height: 400px;
  min-width: 800px;
  width: 100%;
  overflow: auto;
}

.content-wrap {
  padding: 4px 0;
}

/* 信息卡片 */
.info-card {
  background: #fafafa;
  border-radius: 6px;
  padding: 16px 20px;
  border: 1px solid #409eff8a;
}
.first-info-card {
  border: 1px solid #409eff8a;
  // background: #fff;
}
.card-title {
  font-size: 15px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 14px;
  padding-bottom: 10px;
  border-bottom: 1px solid #c2c2c2;
}
.hotel_title {
  border-bottom: 1px solid #c2c2c2;
}
/* 字段行 */
.field-row {
  display: flex;
  align-items: center;
  padding: 6px 0;
  line-height: 1.6;
}

.field-label {
  font-size: 13px;
  color: #909399;
  white-space: nowrap;
  min-width: 80px;
  flex-shrink: 0;
}

.field-value {
  font-size: 14px;
  color: #303133;
  word-break: break-all;
}

/* 下单信息行 */
.order-row {
  padding: 4px 0;

  .field-label {
    min-width: 0px;
    &::after {
      content: '：';
    }
  }
}

/* 入住人 */
.guest-section {
  margin-top: 4px;
}

.guest-title {
  font-size: 14px;
  font-weight: 600;
  color: #409eff;
  margin-bottom: 10px;
  padding-left: 8px;
  border-left: 3px solid #409eff;
}

.guest-table {
  margin-top: 10px;
}

/* 底部按钮 */
.footer-btn {
  text-align: center;
  margin-top: 30px;
  padding-bottom: 10px;
}
</style>
